import { useAuth } from '../hooks/useAuth';
import { useActivityHeartbeat } from '../hooks/useActivityHeartbeat';

/**
 * Mount this once at the app root inside the AuthProvider, it pings
 * `profiles.last_active_at` while the customer is logged in and viewing
 * the tab. Used by the admin-side email cron to skip notifications when
 * the customer is actively online.
 *
 * Renders nothing.
 */
export default function ActivityHeartbeat() {
  const { user } = useAuth();
  useActivityHeartbeat(user?.id);
  return null;
}
